import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../../shared/components/base-page.component';
import { AuthenticationService } from '../../../shared/authentication/authentication.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'pricing-page',
    standalone: true,
    imports: [...BasePage.BaseImports],
    templateUrl: './PricingPage.html',
    styleUrl: './PricingPage.css',
})

export class PricingPage implements BasePage, OnInit
{
    isLoggedIn$ = new BehaviorSubject<boolean | null>(null);
    freeUrl$ = new BehaviorSubject<string>('#');
    subscribeStarterUrl$ = new BehaviorSubject<string>('#');
    subscribeProUrl$ = new BehaviorSubject<string>('#');

    constructor(private authenticationService: AuthenticationService, private router: Router)
    {
    }

    async ngOnInit()
    {
        this.isLoggedIn$.next(await this.authenticationService.checkLoginAsync());

        const freeUrl = this.isLoggedIn$.value
            ? 'https://app.urlo.site/'
            : this.router.createUrlTree(['/builder']).toString()
        this.freeUrl$.next(freeUrl);
        const subscribeStarterUrl = this.isLoggedIn$.value
            ? this.router.createUrlTree(['/subscribe', 'starter']).toString()
            : this.router.createUrlTree(['/account/register', 'starter']).toString();
        this.subscribeStarterUrl$.next(subscribeStarterUrl);
        const subscribeProUrl = this.isLoggedIn$.value
            ? this.router.createUrlTree(['/subscribe', 'pro']).toString()
            : this.router.createUrlTree(['/account/register', 'pro']).toString();
        this.subscribeProUrl$.next(subscribeProUrl);
    }
}
